import { Theme } from "@mui/material";

const jobBenefitsStyle = {
  card: (theme: Theme) => ({
    height: "100%",
    backgroundColor: theme.palette.background.light,
    border: "1px solid " + theme.palette.divider,
  }),
};

export default jobBenefitsStyle;
